import React, { useMemo } from "react";
import { useTranslations } from "../hooks/use-translations";
import { BooksSection } from "./seccion-libros";
import { useUserBooks } from "../hooks/useUserBooks";
import _ from "lodash";
import { useLanguage } from "../hooks/use-language";


/**
 * Componente que muestra la sección de libros aleatorios.
 * @returns {JSX.Element} Elemento JSX que representa la sección de libros aleatorios.
 */
export const RandomBooksSection = () => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "busqueda", lang: lang });
    const userBooks = useUserBooks();
    const books = userBooks?.books;
	const randomBooks = useMemo(() => {
        return _.shuffle(books).slice(0, 8);
    }, [books]);
        
   
	return (
		<>
			<div className="d-lg-flex mt-4 mt-lg-0 mb-3">
				<div className="col-lg-6 px-0 d-flex align-items-center">
					<h3 tabIndex={0} className="focusable-secondary blue-dark--color">
						{`${texts?.libros?.resultados?.titulo || "Resultados"} (0)`}
					</h3>
				</div>
			</div>
			<div className="onbackground-primary--color">
				<div className="no-result p-4">
					<p className="font-weight-bold">
						{texts?.filtro?.no_hay_resultados?.lo_sentimos ||
							"Lo sentimos, no hay resultados para tu búsqueda. "}
					</p>
					<p className="mt-3 font-weight-bold">
						{texts?.filtro?.no_hay_resultados?.recordamos ||
							"Te recordamos que en MakeMake encuentras libros en español para niños y jóvenes."}
					</p>
				</div>
				<h3 tabIndex={0} className="focusable-secondary blue-dark--color  mt-3 mb-5">
					{texts?.filtro?.no_hay_resultados?.otros_libros ||
						"¡Quizá te interesen estos libros!"}
				</h3>

				<BooksSection books={randomBooks} showHeader={false} />
			</div>
		</>
	);
};
